import { createAction } from '@reduxjs/toolkit';
import { SET_ROOMS, UPDATE_ROOMS } from '../constants/rooms';
import { SHOW_MORE_ROOMS } from '../../constants';

export const setRoomsAction = (payload) => ({
  type: SET_ROOMS,
  payload,
});

export const updateRoomsAction = (payload) => ({
  type: UPDATE_ROOMS,
  payload,
});

export const showMoreRoomsAction = createAction(SHOW_MORE_ROOMS);
